import { render } from "./LegendSeatsItem.vue?vue&type=template&id=ef50c19a&scoped=true"
import script from "./LegendSeatsItem.vue?vue&type=script&lang=js"
export * from "./LegendSeatsItem.vue?vue&type=script&lang=js"

import "./LegendSeatsItem.vue?vue&type=style&index=0&id=ef50c19a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef50c19a"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
